import * as PIXI from 'pixi.js'
import { clear } from '../utils'

export default function ShieldManually(
  layerInfo,
  options,
  container,
  renderer,
) {
  clear(container)
  const shieldManually = layerInfo.data
  if (!shieldManually) return

  const shieldManuallyData = shieldManually.shield
  const cols = shieldManually.col
  const rows = shieldManually.row
  const box = options.box
  const blockWidth = (options.width - box.left - box.right) / cols
  const blockHeight = (options.height - box.top - box.bottom) / rows

  const particleContainer = new PIXI.ParticleContainer(
    shieldManuallyData.filter(i => i !== 0).length,
  )
  container.addChild(particleContainer)

  const graphic = new PIXI.Graphics()
  graphic.beginFill(0x84bf96, 0.3)
  graphic.lineStyle(1, 0x84bf96, 0.3)
  graphic.drawRect(0, 0, blockWidth, blockHeight)
  const texture = renderer.generateTexture(graphic)

  for (let i = 0, j = shieldManuallyData.length; i < j; i++) {
    const shieldValue = shieldManuallyData[i]
    if (shieldValue === 0) continue
    const row = Math.floor(i / cols)
    const col = i % cols
    const x = col * blockWidth
    const y = row * blockHeight + (Number(box.top) || 0)

    const rectangle = new PIXI.Sprite(texture)
    rectangle.x = x
    rectangle.y = y

    particleContainer.addChild(rectangle)
  }
  return container
}
